// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scl--jp-mai-con-st{
    width: 100%;
    display: flex;
    flex-direction: column;
    height: calc(100vh - 144px);
    position: relative;
    background-color: #000000;
}

.scl--jmcs-abs-cont-st{
    position: absolute;
    width: 100%;
    height: 90px;
    top: 0px;
}

.scl--jpmcs-res-sh-st{
    width: 100%;
    height: 45px;
    padding-left: 20px;
    padding-right: 20px;
    display: flex;
    align-items: center;
    background-color: rgba(28, 27, 27, 1);
    border: 1px solid rgba(255, 255, 255, 0.05);
}

.scl--jpmcs-res-sh-st span{
    color: rgba(125, 129, 135, 1);
    font-size: 16px;
    font-family: var(--primary-font);
}


.scl--jmcs-lis-ite-ca-eac-st{
    position: absolute;
    top: 90px;     
    bottom: 0;      
    width: 100%;
    height: calc(100% - 90px);
    padding: 20px;
    overflow-y: auto;
    overflow-x: hidden;
}

.scl--jliceas-ite-st{
    width: 100%;
    height: 38px;
    margin-bottom: 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    display: flex;
    justify-content: space-between;
    align-items: start;
    cursor: pointer;
}

.scl--jliceas-ite-st h6{
    color: rgba(255, 255, 255, 1);
    padding: 0px;
    margin: 0px;
    font-size: 18px;
    font-family: var(--primary-font);
    font-weight: lighter;
}

.scl--jis-loc-bo-co-st{
    display: flex;
    height: 100%;
    align-items: start;
    gap: 10px;
}

.scl--jis-loc-bo-co-st span{
    font-size: 18px;
    font-family: var(--primary-font);
    color: rgba(125, 129, 135, 1);
}

.scl--jliceas-ite-st svg path{
    transition: all 0.3s;
}

.scl--jliceas-ite-st:hover svg path{
    stroke: #fff;
}


.scl--jpcb-con-st button{
    margin: 0;
    padding: 20px 20px 20px 10px;
    border: none;
    background-color: transparent;
}

@media (max-width: 500px) {
    .scl--jp-mai-con-st{
        height: calc(100vh - 189px);
    }
}

`, "",{"version":3,"sources":["webpack://./src/page-module/page-services/job-position/css/jobPosition.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,qCAAqC;IACrC,2CAA2C;AAC/C;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,gCAAgC;AACpC;;;AAGA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iDAAiD;IACjD,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,WAAW;IACX,eAAe;IACf,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gCAAgC;IAChC,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;;AAGA;IACI,SAAS;IACT,4BAA4B;IAC5B,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ","sourcesContent":[".scl--jp-mai-con-st{\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    height: calc(100vh - 144px);\n    position: relative;\n    background-color: #000000;\n}\n\n.scl--jmcs-abs-cont-st{\n    position: absolute;\n    width: 100%;\n    height: 90px;\n    top: 0px;\n}\n\n.scl--jpmcs-res-sh-st{\n    width: 100%;\n    height: 45px;\n    padding-left: 20px;\n    padding-right: 20px;\n    display: flex;\n    align-items: center;\n    background-color: rgba(28, 27, 27, 1);\n    border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.scl--jpmcs-res-sh-st span{\n    color: rgba(125, 129, 135, 1);\n    font-size: 16px;\n    font-family: var(--primary-font);\n}\n\n\n.scl--jmcs-lis-ite-ca-eac-st{\n    position: absolute;\n    top: 90px;     \n    bottom: 0;      \n    width: 100%;\n    height: calc(100% - 90px);\n    padding: 20px;\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n\n.scl--jliceas-ite-st{\n    width: 100%;\n    height: 38px;\n    margin-bottom: 20px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n    display: flex;\n    justify-content: space-between;\n    align-items: start;\n    cursor: pointer;\n}\n\n.scl--jliceas-ite-st h6{\n    color: rgba(255, 255, 255, 1);\n    padding: 0px;\n    margin: 0px;\n    font-size: 18px;\n    font-family: var(--primary-font);\n    font-weight: lighter;\n}\n\n.scl--jis-loc-bo-co-st{\n    display: flex;\n    height: 100%;\n    align-items: start;\n    gap: 10px;\n}\n\n.scl--jis-loc-bo-co-st span{\n    font-size: 18px;\n    font-family: var(--primary-font);\n    color: rgba(125, 129, 135, 1);\n}\n\n.scl--jliceas-ite-st svg path{\n    transition: all 0.3s;\n}\n\n.scl--jliceas-ite-st:hover svg path{\n    stroke: #fff;\n}\n\n\n.scl--jpcb-con-st button{\n    margin: 0;\n    padding: 20px 20px 20px 10px;\n    border: none;\n    background-color: transparent;\n}\n\n@media (max-width: 500px) {\n    .scl--jp-mai-con-st{\n        height: calc(100vh - 189px);\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
